import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/konsoll/api")({
	beforeLoad: () => {
		throw redirect({ to: "/account/konsoll/api" });
	},
});
